/**
 * Admin Types - ตาม Angular + fields เพิ่มเติม
 */

// Admin Group (ตาม Angular backend)
export enum AdminGroup {
  SUPER_ADMIN = 0,  // ใหญ่สุด
  ADMIN = 1,
  PARTNER = 3,
}

// Admin Status (ตาม Angular)
export type AdminStatus = 
  | 'Active'      // ปกติ
  | 'Suspend'     // ระงับ
  | 'Watchout'    // เฝ้าระวัง
  | 'Inactive'    // ไม่เคลื่อนไหว
  | 'Pending'     // รอดำเนินการ
  | 'Rejected'    // ถูกปฏิเสธ
  | 'Cancel';     // ยกเลิก

// Admin Interface (Angular fields + React additions)
export interface Admin {
  id: string;
  
  // === Angular fields ===
  username: string;           // สำหรับ login
  firstname: string;
  lastname: string;
  admin_tel?: string;         // เบอร์โทรศัพท์
  line_id?: string;           // LINE ID (ซ่อนใน UI)
  status: AdminStatus;
  admin_group: AdminGroup;
  permissions?: string[];
  
  // === React additions (Angular ไม่มีแต่เราใช้) ===
  email?: string;             // อีเมล (optional)
  twoFactorEnabled: boolean;  // 2FA
  lastLogin?: string;         // เข้าสู่ระบบล่าสุด
  lastLoginIp?: string;       // IP ล่าสุด
  
  // === Metadata ===
  createdAt?: string;
  updatedAt?: string;
  createdBy?: string;
}

// Admin Group Config (สำหรับ UI)
export const ADMIN_GROUP_CONFIG: Record<AdminGroup, { 
  label: string; 
  labelTh: string;
  color: string;
  description: string;
}> = {
  [AdminGroup.SUPER_ADMIN]: {
    label: 'Super Admin',
    labelTh: 'ซุปเปอร์แอดมิน',
    color: 'bg-gradient-to-r from-amber-500 to-orange-500 text-white',
    description: 'สิทธิ์สูงสุด จัดการได้ทุกอย่าง',
  },
  [AdminGroup.ADMIN]: {
    label: 'Admin',
    labelTh: 'แอดมิน',
    color: 'bg-purple-500/10 text-purple-500',
    description: 'จัดการระบบตามสิทธิ์ที่กำหนด',
  },
  [AdminGroup.PARTNER]: {
    label: 'Partner',
    labelTh: 'พาร์ทเนอร์',
    color: 'bg-blue-500/10 text-blue-500',
    description: 'ดูข้อมูลและรายงานตามสิทธิ์',
  },
};

// Admin Status Config (สำหรับ UI)
export const ADMIN_STATUS_CONFIG: Record<AdminStatus, {
  label: string;
  color: string;
  bgColor: string;
}> = {
  'Active': {
    label: 'ปกติ',
    color: 'text-green-500',
    bgColor: 'bg-green-500/10',
  },
  'Suspend': {
    label: 'ระงับ',
    color: 'text-red-500',
    bgColor: 'bg-red-500/10',
  },
  'Watchout': {
    label: 'เฝ้าระวัง',
    color: 'text-yellow-500',
    bgColor: 'bg-yellow-500/10',
  },
  'Inactive': {
    label: 'ไม่เคลื่อนไหว',
    color: 'text-gray-500',
    bgColor: 'bg-gray-500/10',
  },
  'Pending': {
    label: 'รอดำเนินการ',
    color: 'text-blue-500',
    bgColor: 'bg-blue-500/10',
  },
  'Rejected': {
    label: 'ถูกปฏิเสธ',
    color: 'text-orange-500',
    bgColor: 'bg-orange-500/10',
  },
  'Cancel': {
    label: 'ยกเลิก',
    color: 'text-slate-500',
    bgColor: 'bg-slate-500/10',
  },
};

// Form data for create/update
export interface AdminFormData {
  username: string;
  password?: string;
  firstname: string;
  lastname: string;
  admin_tel?: string;
  email?: string;
  admin_group: AdminGroup;
  status: AdminStatus;
  twoFactorEnabled?: boolean;
  permissions?: string[];
}

// Query params
export interface AdminQueryParams {
  page?: number;
  limit?: number;
  search?: string;
  status?: AdminStatus;
  admin_group?: AdminGroup;
  orderBy?: 'asc' | 'desc';
  orderByField?: string;
}





